import config from "../config/config";
import { applyThemeCss } from "./themeCss";
import { applyThemeFavicon } from "./themeFavicon";
import { buildCompanyPath } from "./landingCompany";

export const THEME_CACHE_KEY = "theme";
export const THEME_CACHE_TIME_KEY = "theme_cache_time";
export const THEME_CACHE_DOMAIN_KEY = "theme_domain";

export function getCachedThemeData() {
  try {
    const raw = localStorage.getItem(THEME_CACHE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== "object") return null;
    return data;
  } catch {
    return null;
  }
}

export function getLoginRedirectPath() {
  return buildCompanyPath("");
}

export function applyMasterThemeAssets(data, linkId, cacheBust) {
  if (!data) return;
  const bust = cacheBust ?? Date.now();
  applyThemeFavicon(data?.favicon, {
    cacheBust: data?.updated_at ?? bust,
  });
  const cssPath = data?.css_file_path;
  if (!cssPath) return;
  const href =
    cssPath.startsWith("http") || cssPath.startsWith("blob:")
      ? cssPath
      : `${config.assetsBaseUrl.replace(/\/$/, "")}/uploads/${String(cssPath).replace(/^\/+/, "")}`;
  applyThemeCss({
    id: linkId,
    href,
    cacheBust: data?.updated_at || bust,
  });
}
